import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import ContentGroupBadge from "./ContentGroupBadge";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(3),
  },
}));

const ContentGroupHeader = props => {
  const classes = useStyles();
  const { actions, breadcrumbs, loading, statusSwitch, view } = props;
  return loading ? (
    <Box height={80} width="100%">
      <PanelLoadingIndicator />
    </Box>
  ) : (
    <Grid
      className={classes.header}
      container
      justifyContent="space-between"
      alignItems="center"
    >
      {breadcrumbs}

      <Grid item xs="auto">
        <Grid container alignItems="center">
          <ContentGroupBadge mediaType={view} />
          {statusSwitch}
          {actions}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContentGroupHeader;
